import React from "react";
import PageBannerImage from "../../images/product-strategy-main-banner.svg";

import IconDiscoveryIdeation from "../../icons/icon-discovery-deation-ps.svg";
import IconIdeaResearchPrototyping from "../../icons/icon-idea-research-prototyping-ps.svg";
import IconDesignSprints from "../../icons/icon-design-sprints-ps.svg";
import IconOpportunityAudit from "../../icons/icon-opportunity-audit-ps.svg";
import IconTransformationStrategyRoadmap from "../../icons/icon-transformation-strategy-roadmap-ps.svg";
import IconTechnologyAudit from "../../icons/icon-technology-audit-ps.svg";
import IconMVPDesign from "../../icons/icon-MVP-design-ps.svg";
import IconProcessDigitizationAutomations from "../../icons/icon-process-ps.svg";
import IconLeverageAnalyticsAI from "../../icons/icon-Leverage-Analytics-ps.svg";
import IconPlatformDesignArchitecture from "../../icons/icon-Platform-Design-Architecture-ps.svg";


import ImageSalesmate from "../../images/services-cs-salesmate.png";
import ImageHtHalf from "../../images/service-cs-ht-half.jpg";
import ImagePODHalf from "../../images/services-cs-pod-half.jpg";

export const mainBannerObj = {
  classes: "product-strategy",
  header: (<>Digital Product <br />Strategy</>),
  content: "Translate your vision into a winning strategy, roadmap, and real ROI with our design, technology, and business expertise!",
  mediaClass: "align-v-center justify-center",
  mediaType: "image",
  mediaSource: PageBannerImage
};


export const pageIntroObj = {
  classes: "section-gap",
  title: "",
  header: (<>Launch disruptive products with confidence</>),
  content: (<><p>Companies that focus on creating new products or services with a strong strategy generate significant value than their peers.  While the research and innovation spend is on the constant rise - over $1.5 trillion worldwide,  40% of research and development spend is wasted across large businesses due to a poor or obscure product strategy and customer acceptance. </p>

    <p>Rapidops leverages its expertise in technology, market research, customer experiences, and data analytics to help global businesses devise disruptive strategies for their mission-critical digital opportunities. Tap into our best minds to bring new product ideas and growth plans to life. Whether it's launching new initiatives or reinventing your business, our global team of thinkers, makers, and doers work with your executives, employees, and customers to deeply understand your vision and customer needs and translate them into digital strategy, prototypes, architectures, roadmaps, and execution plans.</p></>)
};


export const devopsblockQuoteObj = {
  classes: "section-gap service-inner-intro",
  header: "Build the right product, reduced risk of delivery, massive cost savings, better customer experiences, and guaranteed ROI.",
};




export const threeColSliderObj = {
  classes: "devops-opportunity",
  header: <>Here’s how we can help invent the winning strategy & deliver on it</>,
  subHeader: <>Shorten the development cycle, accelerate your digital transformation and move at high velocity to serve customers better.</>,
  items: [
    {
      icon: <IconDiscoveryIdeation />,
      header: "Discovery & Ideation",
      content: "Make your product valuable with focused market research, customer profiling, and competition analysis from industry experts."
    }, {
      icon: <IconIdeaResearchPrototyping />,
      header: "Idea Research & Prototyping",
      content: "Empathize and better understand your users by validating ideas, design assumptions, and other aspects of design thinking and gain a competitive advantage."
    }, {
      icon: <IconDesignSprints />,
      header: "Design Sprints",
      content: "Build concept sprints to solve complex business problems and accelerate business growth."
    }, {
      icon: <IconOpportunityAudit />,
      header: "Opportunity Audit",
      content: "Conduct a digital audit to unlock new opportunities by reshaping, redefining, and modeling new approaches to launch the product."
    },
    {
      icon: <IconTransformationStrategyRoadmap />,
      header: "Transformation Strategy & Roadmap",
      content: "Speed up the time to market and stay ahead of the competition to achieve faster ROI through the continuous delivery approach."
    }, {
      icon: <IconTechnologyAudit />,
      header: "Technology Audit",
      content: "Create stable, secure, and highly resilient  architecture, engineering, and deployment practices for all digital apps to drive efficiency and elasticity."
    }, {
      icon: <IconMVPDesign />,
      header: "MVP Design & Launch in 6 Weeks",
      content: "Dramatically improve the time to market and reduce cost with proven MVP strategy and launch your easy-to-use and engaging product with confidence."
    }, {
      icon: <IconProcessDigitizationAutomations />,
      header: "Process Digitization & Automation",
      content: "Achieve operational efficiency with process reshape, automation, program management, organization readiness, communications, and change management."
    }, {
      icon: <IconLeverageAnalyticsAI />,
      header: "Leverage Analytics & AI",
      content: "Bring more value to your digital product with advanced analytics and AI to turn your data into actionable insights."
    }, {
      icon: <IconPlatformDesignArchitecture />,
      header: "Platform Design & Architecture",
      content: "Drive successful transformation and unlock new digital opportunities with powerful vision and strategy from idea to execution."
    }
  ]
};

export const succesStoriesObj = {
  classesForFullColumn: "cs-salesmate",
  imageForFullColumn: ImageSalesmate,
  imageAltForFullColumn: "Salesmate CRM Dashboard",
  imageTitleForFullColumn: "crm dashboard",
  categoryForFullColumn: "CRM",
  headerForFullColumn: "The sales CRM made for you",
  subHeaderForFullColumn: (<>Organize your sales process, win more deals, and create happy customers with automated sales CRM.</>),
  linkForFullColumn: '/work/salesmate-sales-crm/',

  classesForhalfColumn1: "cs-ht-hlaf",
  imageForHalfColumn1: ImageHtHalf,
  imageAltForHalfColumn1: "Omnichannel Retail Experience",
  imageTitleForHalfColumn1: "omnichannel retail platform",
  categoryForHalfColumn1: "Retail",
  headerForHalfColumn1: "Harris Teeter",
  linkForForHalfColumn1: '/work/harris-teeter-online-grocery-shopping/',

  classesForhalfColumn2: "cs-pod-hlaf",
  imageForHalfColumn2: ImagePODHalf,
  imageAltForHalfColumn2: "last-mile-automation",
  imageTitleForHalfColumn2: "last-mile-automation",
  categoryForHalfColumn2: "LOGISTICS",
  headerForHalfColumn2: "Reinventing last mile delivery",
  linkForForHalfColumn2:'/work/last-mile-automation/',

};


export const ctaObj = {
  title: <>Rapidops Design Sprint</>,
  subtitle: <>Transform your ideas into validated strategy in less than <strong>2 weeks</strong>.</>,
};